export function fuzzyMatch(text: string, query: string): boolean {
  const normalizedText = text.toLowerCase()
  let queryIndex = 0
  for (let i = 0; i < normalizedText.length; i += 1) {
    if (normalizedText[i] === query[queryIndex]) {
      queryIndex += 1
      if (queryIndex === query.length) {
        return true
      }
    }
  }
  return queryIndex === query.length
}
